import * as React from "react";
import { cn } from "../utils/cn";

export interface SelectProps extends Omit<React.SelectHTMLAttributes<HTMLSelectElement>, 'onChange'> {
  error?: string;
  onChange?: React.ChangeEventHandler<HTMLSelectElement>;
  onValueChange?: (value: string) => void;
}

export const Select = React.forwardRef<HTMLSelectElement, SelectProps>(
  ({ className, error, children, onChange, onValueChange, ...props }, ref) => {
    const baseClass =
      "flex h-11 w-full rounded-lg border border-gray-200 bg-white px-3 py-2 text-sm shadow-sm transition focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-500 focus-visible:ring-offset-1 disabled:cursor-not-allowed disabled:opacity-60";
    const errorClass = error ? "border-danger-500 focus-visible:ring-danger-500" : "";

    const handleChange = React.useCallback((e: React.ChangeEvent<HTMLSelectElement>) => {
      onChange?.(e);
      onValueChange?.(e.target.value);
    }, [onChange, onValueChange]);

    return (
      <div className="flex w-full flex-col gap-1">
        <select
          ref={ref}
          className={cn(baseClass, errorClass, className)}
          onChange={handleChange}
          {...props}
        >
          {children}
        </select>
        {error ? <span className="text-xs text-danger-600">{error}</span> : null}
      </div>
    );
  }
);

Select.displayName = "Select";
